import InviteToGroupModal from './InviteToGroupModal';
import InviteToGroupModalContainer from './InviteToGroupModal.container';
export default InviteToGroupModalContainer(InviteToGroupModal);
